import Activities from "../../Activities/components/Activities";

const SelfAssessments = () => <Activities startActivityType={3}/>

export default SelfAssessments;